export default __webpack_public_path__ + "4b2522af4e74738fc1c4496f2289444e.jpg";